import createFastContext from '../../utils/hooks/createFastContext';
var defaultState = {
    filteredRowsCount: 0,
    markedRows: [],
    selectedRow: null,
    quickSearch: '',
    autoColumnWidth: true,
    isCompactList: false,
    gridApi: null,
    gridColumnApi: null,
    columnState: [],
};
var _a = createFastContext(defaultState), ListViewContextProvider = _a.Provider, useListViewStore = _a.useStore, useListViewStoreGetter = _a.useStoreGetter, useListViewStoreSetter = _a.useStoreSetter, useListViewContextAvailable = _a.useContextAvailable;
export { ListViewContextProvider, useListViewStore, useListViewStoreGetter, useListViewStoreSetter, useListViewContextAvailable, };
//# sourceMappingURL=useListView.js.map